export const CALL_WALLID_METHOD = 'CALL_WALLID_METHOD';
export const INITIATE_PLUGIN = 'INITIATE_PLUGIN';

export const WALLET_ADDRESS = 'wallet_address';
export const WALLET_ONBOARDING = 'wallid_onboarding';
// export const WALLET_LIST = 'wallid_identities';
export const WALLET_LIST = 'wallid_list';
export const WALLET_CONNECT = 'wallid_connect';
export const WALLID_EXPORT = 'wallid_export_asset';
export const WALLET_SIGN = 'wallet_sign';
